'use strict';

module.exports = FormData;



//////////////////
// WEBPACK FOOTER
// /home/runner/work/RS-rydges2018-docker/RS-rydges2018-docker/wp-content/themes/rydges/node_modules/axios/lib/platform/browser/classes/FormData.js
// module id = 212
// module chunks = 0